// MonthlyFeeVoucher.jsx
import React, { useEffect, useState } from "react";

export const VoucherContent = ({ data, hideHeader }) => (
  <div style={{ fontSize: '11px', fontFamily: 'Arial, sans-serif', color: '#000' }}>
    {/* Header */}
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '4px' }}>
      {!hideHeader ? (
        <>
          <div style={{ width: '70px', height: '70px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 'bold', flexShrink: 0, overflow: 'hidden', background: 'transparent', border: 'none' }}>
            {data.centerImagePath ? (
              <img 
                src={data.centerImagePath.startsWith('http') 
                  ? data.centerImagePath 
                  : `${process.env.REACT_APP_LIVE_DOMAIN_URL || ''}${process.env.REACT_APP_LIVE_DOMAIN_URL?.endsWith('/') ? '' : '/'}ExternalImages${data.centerImagePath.startsWith('/') ? '' : '/'}${data.centerImagePath}`} 
                alt="Logo" 
                style={{ width: '100%', height: '100%', objectFit: 'contain' }} 
              />
            ) : 'LOGO'}
          </div>
          <div style={{ textAlign: 'center', flex: 1, padding: '0 8px' }}>
            <div style={{ fontSize: '13px', fontWeight: 'bold', lineHeight: '1.2' }}>KAHNUR EDUCATION HOUSE HIGH SCHOOL FOR BOYS & GIRLS</div>
            <div style={{ textAlign: 'right', fontSize: '10px', fontWeight: 'bold' }}>Fee Slip</div>
          </div>
        </>
      ) : <div style={{ flex: 1 }}></div>}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flexShrink: 0 }}>
        <img
          src={`https://bwipjs-api.metafloor.com/?bcid=code128&text=${data.acNo}&scale=5&rotate=N&includetext=false`}
          alt="Barcode"
          style={{ width: '120px', height: '35px', imageRendering: 'pixelated' }}
        />
        <span style={{ fontSize: '9px', fontWeight: 'bold', marginTop: '2px' }}>{data.acNo}</span>
      </div>
    </div>

    {/* Body */}
    <div style={{ display: 'flex', gap: '8px' }}>
      {/* Left */}
      <div style={{ flex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '2px' }}>
          <span style={{ fontWeight: 'bold' }}>A/C #</span>
          <span style={{ background: '#ddd', padding: '0 8px', fontWeight: 'bold', border: '1px solid #999' }}>{data.acNo}</span>
          <span style={{ fontWeight: 'bold', marginLeft: '6px' }}>Class</span>
          <span style={{ borderBottom: '1px solid #000', flex: 1, textAlign: 'center', fontWeight: 'bold' }}>{data.className}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '2px' }}>
          <span style={{ fontWeight: 'bold', width: '90px', whiteSpace: 'nowrap' }}>Fee Voucher For</span>
          <span style={{ borderBottom: '1px solid #000', flex: 1, textAlign: 'center', fontWeight: 'bold', textTransform: 'uppercase' }}>{data.feeTypeName}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '2px' }}>
          <span style={{ fontWeight: 'bold', width: '90px' }}>Student Name</span>
          <span style={{ borderBottom: '1px solid #000', flex: 1, fontWeight: 'bold', textTransform: 'uppercase', fontSize: '12px' }}>{data.studentName}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '2px' }}>
          <span style={{ fontWeight: 'bold', width: '90px' }}>Father's Name</span>
          <span style={{ borderBottom: '1px solid #000', flex: 1, fontWeight: 'bold', textTransform: 'uppercase', fontSize: '12px' }}>{data.fatherName}</span>
        </div>

        <div style={{ marginTop: '6px' }}>
          <div style={{ border: '1px solid #000', padding: '0 4px', display: 'inline-block', fontSize: '9px', fontWeight: 'bold', marginBottom: '3px' }}>
            School Contact # {data.contact}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 12px', fontSize: '9px', fontWeight: 'bold' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000' }}><span>Paper Fund</span><span style={{ fontSize: '10px' }}>{data.paperFund}</span></div>
            <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000' }}><span>Fine</span><span style={{ fontSize: '10px' }}>{data.fine}</span></div>
            <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000' }}><span>Other</span><span style={{ fontSize: '10px' }}>{data.other}</span></div>
            <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000' }}><span>Transprot Fee</span><span style={{ fontSize: '10px' }}>{data.transportFee}</span></div>
          </div>
          <p style={{ fontSize: '7px', marginTop: '2px', color: '#888', fontStyle: 'italic' }}>
            Software By: Inspirer software technologies
          </p>
        </div>
      </div>

      {/* Right - Fee breakdown */}
      <div style={{ width: '220px', fontSize: '10px', fontWeight: 'bold' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000', padding: '1px 0' }}><span>Tution Fee</span><span style={{ fontSize: '12px' }}>{data.tutionFee}</span></div>
        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000', padding: '1px 0' }}><span>Balance</span><span style={{ fontSize: '12px' }}>{data.balance}</span></div>
        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000', padding: '1px 0' }}>
          <span style={{ lineHeight: '1.1', fontSize: '9px', whiteSpace: 'nowrap' }}>Annual Stationery Charges Per Month</span>
          <span style={{ fontSize: '12px' }}>{data.annualStationery}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #000', padding: '1px 0' }}><span>Stationery</span><span style={{ fontSize: '12px' }}>{data.stationery}</span></div>
        
        <div style={{ marginTop: '6px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', background: '#f3f3f3', padding: '2px 4px', border: '1px solid #000', borderBottom: '1px solid #000', fontWeight: 'bold' }}>
            <span style={{ whiteSpace: 'nowrap' }}>Total Payable by {data.dueDate}</span>
            <span style={{ fontSize: '15px', marginLeft: '4px' }}>{data.totalDue}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '2px 4px', borderBottom: '1px solid #000', fontWeight: 'bold' }}>
            <span style={{ whiteSpace: 'nowrap' }}>Total Payable After {data.dueDate}</span>
            <span style={{ fontSize: '15px', marginLeft: '4px' }}>{data.totalAfter}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const MonthlyFeeVoucher = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem('customVoucherData');
    if (stored) {
      setData(JSON.parse(stored));
    }
  }, []);

  if (!data) return <div style={{ padding: '40px', textAlign: 'center', fontSize: '16px' }}>Loading voucher data...</div>;

  return (
    <>
      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { margin: 0; padding: 0; }
          .voucher-page { padding: 15px !important; box-shadow: none !important; border: none !important; }
        }
        body { font-family: 'Arial', sans-serif; color: black; margin: 0; }
        .dashed-line { border-top: 2px dashed #000; margin: 12px 0; position: relative; }
        .dashed-line::after { content: '✂️ Cut Here'; position: absolute; top: -10px; left: 50%; transform: translateX(-50%); background: white; padding: 0 8px; font-size: 10px; }
      `}</style>

      <div style={{ background: '#f3f4f6', padding: '20px', minHeight: '100vh' }}>
        <div className="voucher-page" style={{ maxWidth: '750px', margin: '0 auto', background: '#fff', padding: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.2)', border: '1px solid #ccc' }}>
          <VoucherContent data={data} />
          <div className="dashed-line"></div>
          <VoucherContent data={data} hideHeader={true} />
        </div>

        <div className="no-print" style={{ textAlign: 'center', marginTop: '12px' }}>
          <button
            onClick={() => window.print()}
            style={{ background: '#16a34a', color: '#fff', padding: '8px 20px', borderRadius: '4px', border: 'none', cursor: 'pointer', fontSize: '14px' }}
          >
            Print Monthly Fee Voucher
          </button>
        </div>
      </div>
    </>
  );
};

export default MonthlyFeeVoucher;